
import React, {useEffect} from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link } from "gatsby"
import {
    FacebookShareButton,
    LinkedinShareButton,
  } from "react-share";

import ImageModule from "../../modules/image_module";
import ContentModule from "../../modules/content_module";
import GuidesListBanner from "../GuidesListBanner/GuidesListBanner";

import "./GuideDetail.scss";

const Insight = ({id, title, content, breadcrumbs, image, imagetransforms, ggfx_results, className }) => {

    const shareurl = typeof window !== 'undefined' ? window.location.href : ''
    const instagramShareUrl = `https://www.instagram.com/?url=${shareurl}`

    var imagename = "guides-and-resources.image.detail_image";
    

    let processedImages = JSON.stringify({});
    if (imagetransforms?.image_Transforms) {
        processedImages = imagetransforms?.image_Transforms;
    }

    const handleInstaShare = () => {
        window.open(instagramShareUrl, '_blank');
    };

    const trackerShare = (event) => {    
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Share - social icons',
          'formType': event + ' - ' +shareurl,
          'formId': 'Share',
          'formName': 'Share',
          'formLabel': 'Share'
        });    
    }

    

    return (
        <React.Fragment>
            <section className={`insight-section ${className} guide_details`}>
                <Container>
                    <Row>
                        <Col>
                            <div className="breadcrumb-section">
                                <Breadcrumb>
                                    {/* <Breadcrumb.Item href="javascript:;" className="d-none">Back to Branch Details</Breadcrumb.Item> */}
                                    <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>
                                    {breadcrumbs?.map((breadcrumb, i, arr) => {
                                        if (arr.length - 1 === i) { // is the last item in the array
                                            return (
                                                <Breadcrumb.Item key={i} active>{breadcrumb.label}</Breadcrumb.Item>
                                            )
                                        } 
                                        else {
                                            return (
                                                <li className="breadcrumb-item"><Link to={`${breadcrumb.url}/`}>{breadcrumb.label}</Link></li>
                                            )
                                        }
                                    })}
                                </Breadcrumb>
                            </div>
                            <div className="content">
                                <h1>{title}</h1>

                                <div className="guide_image">
                                    <ImageModule ImageSrc={image} altText={image?.alternativeText ? image?.alternativeText : title} imagetransforms={processedImages} ggfx_results={ggfx_results} renderer="srcSet" imagename={imagename} strapi_id={id}/>
                                </div>

                                <div className="content_wrapper">
                                    <ContentModule Content={content} />
                                </div>

                                <div className="share_guide">
                                    <h3>Share this Guide</h3>

                                    <div className="social-links">
                                        <FacebookShareButton onClick={()=>trackerShare('FacebookShareButton')} url={shareurl} className="my-share-button facebook-share">
                                            <i className="icon-fb"></i>
                                        </FacebookShareButton>

                                        <a href="javascript:;" aria-label="instagram" className="my-share-button" onClick={() => {handleInstaShare(); trackerShare('FacebookShareButton')}}>
                                            <i className="icon-insta"></i>
                                        </a>

                                        <LinkedinShareButton onClick={()=>trackerShare('LinkedinShareButton')} url={shareurl} className="my-share-button linkedin-share">
                                            <i className="icon-linkedin"></i>
                                        </LinkedinShareButton>
                                    </div>
                                </div>

                                <GuidesListBanner />
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default Insight;